import { writable } from 'svelte/store';

export let selectedCarePlan = writable({});
export let selectedHostingPlan = writable({});
